<div
  class="offline-state"
  [class.offline-state--compact]="compact()"
  [class.offline-state--blocking]="blocking()"
  role="status"
  aria-live="polite"
>
  <!-- Inline SVG rather than an icon font: this state is at its most useful offline, where a font
       that missed the service-worker cache would render as a blank box. -->
  <svg class="offline-state__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M2 4.5 3.4 3 21 20.6 19.6 22l-3.2-3.2A9.6 9.6 0 0 1 12 20a9.6 9.6 0 0 1-6.7-2.7l1.4-1.4A7.6 7.6 0 0 0 12 18c1.1 0 2.2-.2 3.1-.7L12.9 15A5 5 0 0 0 9 16.2l-1.4-1.4a7 7 0 0 1 3.5-1.9L9.4 11.4a9 9 0 0 0-3 1.9L5 11.9a11 11 0 0 1 2.9-2L6.2 8.2a13 13 0 0 0-2.8 2.1L2 8.9c.8-.8 1.7-1.5 2.7-2.1L2 4.5Zm10.9 3.1a13 13 0 0 1 8.4 3.7l-1.4 1.4a11 11 0 0 0-5.4-2.8l-1.6-2.3ZM12 19.2a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8Z"
    />
  </svg>

  <div class="offline-state__text">
    <p class="offline-state__title">{{ title() | translate }}</p>
    <p class="offline-state__body">{{ body() | translate }}</p>
  </div>

  @if (canRetry()) {
    <button type="button" class="offline-state__retry" (click)="retry.emit()">{{ "NETWORK.RETRY" | translate }}</button>
  }
</div>
